import {
  TrendingUp as TrendingUpIcon,
  SupervisorAccount as SupervisorAccountIcon,
  Assignment as AssignmentIcon,
  Info as InfoIcon,
  Gavel as GavelIcon,
  BusinessCenter as BusinessCenterIcon,
} from '@material-ui/icons';
import { ru } from 'locale';

const sections = [
  {
    name: ru.accounting,
    url: 'accounting',
    icon: TrendingUpIcon,
  },
  {
    name: ru.beneficiaries,
    url: 'beneficiaries',
    icon: SupervisorAccountIcon,
  },
  {
    name: ru.companyAffiliates,
    url: 'company-affiliates',
    icon: InfoIcon,
  },
  {
    name: ru.courts,
    url: 'cases',
    icon: GavelIcon,
  },
  {
    name: ru.executiveProceedings,
    url: 'fssp',
    icon: AssignmentIcon,
  },
  {
    name: ru.governmentContracts,
    url: 'contracts',
    icon: BusinessCenterIcon,
  },
];

export default sections;
